export const PAYMENT_SETTING = 'paymentsetting';
export const WITHIN_CHECKOUT = 'withincheckout';
